// Region of the legacy data, as the shared authentication core (src/auth) and its screens read it.
//
// The legacy API serves two regional databases chosen per request by the `location` header; the
// `auth/*` functions treat that header as a hint and locate people, organizations and invitations
// themselves. Signed in, the app already knows the region (`localStorage.orgLocation`, written at
// sign-in from the session or the organization); signed out, nothing has to be resolved up front —
// so this module only remembers, it never calls the API. (The other Dosen app resolves the region
// against a directory endpoint before mounting; the legacy API has no such endpoint.)

export type Region = 'us' | 'eu';

const REGION_KEY = 'orgLocation';

export const isRegion = (value: string): value is Region => value === 'us' || value === 'eu';

/** The region the app last worked in, or null when it has none to offer (the API decides). */
export const getDefaultRegion = (): Region | null => {
  try {
    const stored = (localStorage.getItem(REGION_KEY) || '').toLowerCase();
    return isRegion(stored) ? stored : null;
  } catch {
    return null;
  }
};
